import _ from 'lodash'
const BUSINESS_DIODES_CONFIG = {
    section: _.select( '.c-section--business-semiconductors-solutions-grid--diodes' ),
    table: _.select( '.c-section--business-semiconductors-solutions-grid--diodes table' ),
    search: _.select( '#form--semiconductors-search input[name="search"]' ),
    select: _.select( '#form--semiconductors-search select' ),
    loader: _.select( '.c-section--business-semiconductors-solutions-grid .table__loader' ),
    endpoint: 'semiconductors/diodes'
}

export default BUSINESS_DIODES_CONFIG